// FormImage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../Actions/setLoading';
import { changedPicture } from '../../Actions/changePic';
import { Form } from 'react-bootstrap';
import Compress from '../../compress';
import { paramsOfTextureViaQueryAction } from '../../Actions/paramsOfTextureAction';
import { uploadImage } from '../../Services/transferData'; // Import uploadImage

const FormImage = ({ queryParams, location, selectedImage }) => {
    const Redirect = useNavigate();
    const dispatch = useDispatch();

    const changeInputValue = (evt) => {
        const compress = new Compress();
        const files = [...evt.target.files];
        compress.compress(files, {
            size: 4,
            quality: 0.75,
            maxWidth: 1920,
            maxHeight: 1920,
            resize: true,
            rotate: false,
        }).then((results) => {
            const output = results[0];
            const file = Compress.convertBase64ToFile(output.data, output.ext);
            let srcValue;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                srcValue = reader.result;
                const res = srcValue;
                submitForm(res);
            };
            dispatch(setLoading());
        });
    };

    const submitForm = async (dataImage) => {
        const formData = new FormData();
        formData.append('img', dataImage);
        if (location) formData.append('location', JSON.stringify(location));
        try {
            const { data, status } = await uploadImage(formData);
            if (status === 200) {
                dispatch(setLoading());
                dispatch(changedPicture(data.data));
                if (queryParams && queryParams.query_string_procode !== null) dispatch(paramsOfTextureViaQueryAction(queryParams.query_string_procode));
            }
            if (window.innerWidth > 800) {
                Redirect('/ariis-w');
            } else {
                Redirect('/ariis-m');
            }
        } catch (err) {
            toast.error("عکس آپلود نشد", {
                position: "bottom-right",
                autoClose: 1500,
                closeButton: true,
                closeOnClick: true,
            });
            setTimeout(() => {
                dispatch(setLoading());
            }, 1000);
        }
    };

    useEffect(() => {
        if (selectedImage) {
            const compress = new Compress();
            const image = new Image();
            image.src = selectedImage;
            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, image.width, image.height);
                canvas.toBlob((blob) => {
                    const file = new File([blob], 'sample-image.png', { type: 'image/png' });
                    compress.compress([file], {
                        size: 4,
                        quality: 0.75,
                        maxWidth: 1920,
                        maxHeight: 1920,
                        resize: true,
                        rotate: false,
                    }).then((results) => {
                        const output = results[0];
                        const file = Compress.convertBase64ToFile(output.data, output.ext);
                        let srcValue;
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = function () {
                            srcValue = reader.result;
                            const res = srcValue;
                            submitForm(res);
                        };
                        dispatch(setLoading());
                    });
                }, 'image/png');
            };
        }
    }, [selectedImage]);

    return (
        <Form className='d-none' method='post'>
            <input type="file" id='file-input' accept="image/*" onChange={(evt) => changeInputValue(evt)} />
            <input type='hidden' />
        </Form>
    );
}

export default FormImage;
